/* Vuex mutations types for module App */
import { hToggleArrayItem } from '../../utils/helpers';

import {
  SHOW_COOKIE_BAR,
  SHOW_INFORMATION_MODAL,
  CLOSE_COOKIE_BAR,
  CLOSE_INFORMATION_MODAL,
  TOGGLE_PENDING_ASYNC_STORE_ACTIONS,
} from './mutations-types';

export default {
  [TOGGLE_PENDING_ASYNC_STORE_ACTIONS](state, payload) {
    state.pendingAsyncStoreActions = hToggleArrayItem(state.pendingAsyncStoreActions, payload);
  },
  [SHOW_INFORMATION_MODAL](state) {
    state.isInformationModalVisible = true;
  },
  [CLOSE_INFORMATION_MODAL](state) {
    state.isInformationModalVisible = false;
  },
  [SHOW_COOKIE_BAR](state) {
    state.isCookieBarVisible = true;
  },
  [CLOSE_COOKIE_BAR](state) {
    state.isCookieBarVisible = false;
  },
};
